import { Dispatch, SetStateAction, useEffect } from 'react'
import { Dialog, DialogContent } from '@mui/material'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getDadosIntegracaoBoleto } from 'services/simulacao/gravarAdesaoAPI'
import { Box } from 'components/Material/index'
import { Progress } from 'components/Custom/Progress'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import { AxiosError } from 'axios'
import { ErrorResponse, HandlerErrorMessage } from 'utils/HandlerErrorMessage'
import { useSnackbarAlertContext } from 'contexts/SnackbarContext'

export interface BoletoData {
  idconv: string
  reftran: string
  valor: string
  dtvenc: string
  tppagamento: string
  cpfcnpj: string
  indicadorpessoa: string
  tpduplicata: string
  nome: string
  endereco: string
  cidade: string
  uf: string
  cep: string
}

type Props = {
  openDialog: boolean
  setOpenDialog: Dispatch<SetStateAction<boolean>>
  idConcc030: number
}

export const FormBoletoMpag = ({ openDialog, setOpenDialog, idConcc030 }: Props) => {
  const CURRENT_URL = window.location.href
  const { showAlert } = useSnackbarAlertContext()

  useEffect(() => {
    if (openDialog) {
      init()
    }
  }, [openDialog])

  const {
    data: boletoData,
    isPending: isLoading,
    mutateAsync
  } = useMutation({
    mutationFn: getDadosIntegracaoBoleto
  })

  const init = async () => {
    try {
      if (idConcc030) {
        await mutateAsync({ idConcc030 })
      } else {
        throw new Error('Erro ao gerar boleto')
      }
    } catch (error) {
      const err = error as AxiosError<ErrorResponse>
      HandlerErrorMessage({ error: err, showAlert })
      handleClose()
    }
  }

  useEffect(() => {
    const form = document.forms.namedItem('pagamento')
    if (form) {
      form.submit()
      setOpenDialog(false)
    }
  }, [boletoData])

  const handleClose = () => {
    setOpenDialog(false)
  }

  return (
    <Dialog open={openDialog} fullWidth maxWidth="sm">
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500]
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers style={{ textAlign: 'center', paddingTop: '50px' }}>
        {isLoading || !boletoData ? (
          <Box className="w-full flex justify-center items-center">
            <Progress />
          </Box>
        ) : (
          boletoData && (
            <Box>
              <span style={{ fontFamily: 'sans-serif', fontSize: '20px', fontWeight: '700' }}>
                Redirecionando para o formulário de pagamento.
              </span>
              <form
                id="pagamento"
                name="pagamento"
                method="POST"
                action="https://mpag.bb.com.br/site/mpag/"
                target="_blank"
              >
                <input type="hidden" name="idConv" value={boletoData.idconv} />
                <input type="hidden" name="refTran" value={boletoData.reftran} />
                <input type="hidden" name="valor" value={boletoData.valor} />
                <input type="hidden" name="dtVenc" value={boletoData.dtvenc} />
                <input type="hidden" name="tpPagamento" value={boletoData.tppagamento} />
                <input type="hidden" name="cpfCnpj" value={boletoData.cpfcnpj} />
                <input type="hidden" name="indicadorPessoa" value={boletoData.indicadorpessoa} />
                <input type="hidden" name="tpDuplicata" value={boletoData.tpduplicata} />
                <input type="hidden" name="urlRetorno" value={CURRENT_URL} />
                <input type="hidden" name="nome" value={boletoData.nome} />
                <input type="hidden" name="endereco" value={boletoData.endereco} />
                <input type="hidden" name="cidade" value={boletoData.cidade} />
                <input type="hidden" name="uf" value={boletoData.uf} />
                <input type="hidden" name="cep" value={boletoData.cep} />
                <input type="hidden" name="msgLoja" value={'Boleto'} />
              </form>
            </Box>
          )
        )}
      </DialogContent>
    </Dialog>
  )
}
